import store from '@/store/index.js'
import i18n from '@/i18n'
import router from '@/router'
import { getMainApp } from '@/helpers/env'

function numberTotwoCharacterString(value) {
    if (value < 10) {
        return `0${value}`
    } else {
        return value.toString()
    }
}
export function clearMail(mail) {
    return mail.replace(/\s+/g, '').toLowerCase()
}
export function clearPhone(phone) {
    return phone.toString().replace(/\D/g, '')
}
export function validateMail(mail) {
    let re = /\S+@\S+\.\S+/
    return re.test(String(mail).toLowerCase())
}
export function displayMinutes(value) {
    let seconds = value * 60
    let hours = Math.floor(seconds / 3600)
    let minutes = Math.floor((seconds - hours * 3600) / 60)
    if (value == -1 || value == null) {
        return '-'
    } else if (minutes == 0) {
        return '00'
    } else {
        return numberTotwoCharacterString(minutes)
    }
}
export function displayHour(minutes) {
    let seconds = minutes * 60
    let hours = Math.floor(seconds / 3600)
    if (minutes == -1 || minutes == null) {
        return '-'
    } else if (minutes == 0) {
        return '00'
    } else {
        return numberTotwoCharacterString(hours)
    }
}
export function getElementPath(event) {
    let el = event.target
    let path = []
    while (el) {
        path.push(el)
        if (el.tagName === 'HTML') {
            path.push(document)
            path.push(window)
            return path
        }
        el = el.parentElement
    }
    return path
}
export function getFileExtension(fileName) {
    return fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
}
export function convertImageUrl(image) {
    const jwt = store.state.user.jwt
    return jwt ? `${image}?jwt=${jwt}` : image
}
export function checkFeature(feature) {
    if (!feature) {
        return true
    }
    if (feature.includes('!')) {
        return !store.state.school.features[feature.replace('!', '')]
    }
    if (
        !store.state.school.features ||
        store.state.school.features[feature] == null ||
        store.state.school.features[feature] == undefined
    ) {
        return true
    }
    return store.state.school.features[feature]
}
export function setForm(inputs, dataToSend, errors) {
    errors.errors = []
    const keys = Object.keys(inputs)
    if (
        keys.some(key => key == 'password') &&
        keys.some(key => key == 'repeatPassword')
    ) {
        if (inputs.password.value != inputs.repeatPassword.value) {
            errors.set('password')
            errors.set('repeatPassword')
        }
    }
    if (
        keys.some(key => key == 'password') &&
        keys.some(key => key == 'old_password')
    ) {
        if (inputs.password.value != inputs.old_password.value) {
            errors.set('password')
            errors.set('old_password')
        }
    }
    keys.forEach(key => {
        if (
            inputs[key].hidden ||
            (inputs[key].value == -1 && inputs[key].type != 'number-input') ||
            inputs[key].disabled
        ) {
            return
        }
        if (
            inputs[key].required == true &&
            inputs[key].value !== 0 &&
            inputs[key].value !== '0' &&
            !inputs[key].value &&
            inputs[key].type != 'switch'
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (
            (inputs[key].type == 'multi-select' ||
                inputs[key].type == 'kid-select') &&
            inputs[key].required == true &&
            inputs[key].value.length == 0
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (
            inputs[key].type == 'attachments-input' &&
            inputs[key].required &&
            !inputs[key].single &&
            inputs[key].value.length == 0
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (
            inputs[key].type == 'attachments-input' &&
            inputs[key].required &&
            inputs[key].single &&
            !inputs[key].value
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (
            inputs[key].type == 'single-select' &&
            inputs[key].required == true &&
            !inputs[key].value
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (inputs[key].skip) {
            return errors.errors.length == 0
        }
        if (typeof inputs[key].value == 'string') {
            if (inputs[key].type == 'number-input') {
                dataToSend[inputs[key].key] = inputs[key].value
                    ? inputs[key].value
                    : ''
            } else {
                dataToSend[inputs[key].key] = inputs[key].value.trim()
            }
        } else {
            dataToSend[inputs[key].key] = JSON.parse(
                JSON.stringify(inputs[key].value)
            )
        }
    })
    return errors.errors.length == 0
}
export const colors = {
    blue: '#17ACFF',
    darkBlue: '#4A90E2',
    green: '#17DDC0',
    red: '#ff6b81',
    yellow: '#F8CC46',
    apple: '#2ed573',
    label: '#9B9B9B',
    orange: '#ff931e',
    purple: '#826af9',
    salmon: '#ffb8b8',
    navy: '#40739e',
    grey: '#c5c5c7',
    brown: '#795548',
    darkRed: '#c23616',
    darkGreen: '#2E7D32',
    darkOrange: '#F7630C',
    darkYellow: '#EAB543',
    darkSalmon: '#e17055',
    darkPurple: '#4527A0',
    fuchsia: '#ff00ff',
    darkkhaki: '#bdb76b',
    indigo: '#4b0082',
    darkolivegreen: '#556b2f',
    beige: '#f5f5dc',
    lightcyan: '#e0ffff',
    gold: '#ffd700',
    aqua: '#00ffff',
    alert: '#FF2544'
}
export function isMobileDevice() {
    return (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i)
    )
}
export function mobileDeviceType() {
    if (navigator.userAgent.match(/Android/i)) {
        return 'android'
    } else if (
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i)
    ) {
        return 'ios'
    }
}
export function setLocale(locale) {
    switch (locale) {
        case 'pl':
            return 'pl_PL'
        case 'en':
            return 'en_GB'
        case 'de':
            return 'de_DE'
        default:
            return 'pl_PL'
    }
}
export const assertLogoutUser = () => logoutUser()

export function logoutUser(_vue) {
    const routeURL = getMainApp()
    store.dispatch('resetStore')
    router.push('/')
    Language.initRegion()
    window.location.href = `${routeURL}?logout=true`
}
export function getAttachmentName(attachment) {
    const uuidV4Regex =
        /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}./i
    const splitArray = attachment.split('/')
    const file = splitArray[splitArray.length - 1].replace(uuidV4Regex, '')
    const extension = getFileExtension(file)
    const filePlaceholder = i18n.t('LABEL_FILE').toLowerCase()
    const name = file == extension ? `${filePlaceholder}.${extension}` : file
    return name
}
